import {
  usePageNumberFromUrl,
  usePerPageValueFromUrl,
  useSortValueFromUrl,
} from 'idsk-react-components';
import { SortDirectionEnum } from 'elegislativa-frontend-ts-axios';
import { ClientStatus } from '../../../../../model/ClientStatus';
import { useClientFetch } from '../../../../../context/ClientStatusContext';
import {
  defaultPerPageValue,
  perPageDataArray,
} from '../../../../../constants/PaginationPerPageConstants';
import { fetchMojeUlohyPage } from '../../../../../client/legislativnyMaterial/mojeUlohyListClient';
import useSearchTextFilterFromUrl from '../../../../../hooks/useSearchTextFilterFromUrl';
import LegislativnyMaterialUlohaListPage
  from '../../../../../model/legislativnyMaterial/ulohy/LegislativnyMaterialUlohaListPage';
import getUlohySort from '../../../../../function/getUlohySort';

interface ReturnType {
  legislativnyMaterialPage: LegislativnyMaterialUlohaListPage;
  requestStatus: ClientStatus;
  pageNumber: number;
  searchText: string;
  reloadMaterialPage
}

const getSortDirection = (sort): SortDirectionEnum => (sort[1] === 'desc'
  ? SortDirectionEnum.Desc
  : SortDirectionEnum.Asc);

export default (ibaMojeLegProcesy: boolean): ReturnType => {
  const { page } = usePageNumberFromUrl();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();
  const filter = useSearchTextFilterFromUrl();

  const {
    data: legislativnyMaterialPage,
    status: requestStatus,
    refetch: reloadMaterialPage,
  } = useClientFetch(
    fetchMojeUlohyPage,
    [page, perPageValue, getUlohySort(sort[0]), getSortDirection(sort), filter ? filter.trim() : filter,
      ibaMojeLegProcesy],
    [page, perPageValue, sort[0], sort[1], filter, ibaMojeLegProcesy],
  );

  return {
    legislativnyMaterialPage,
    requestStatus,
    pageNumber: page,
    searchText: filter,
    reloadMaterialPage,
  };
};
